import { SxProps, Theme } from '@mui/material';

export const getEmptyStateStyles = (): SxProps<Theme> => ({
     display: 'flex',
     gap: 2,
     alignItems: 'center',
});

export const getDisabledAddButtonStyles = (): SxProps<Theme> => ({
     opacity: 0.3,
     color: '#9FB1BD',
     alignSelf: 'center',
}); 